import React, { useState } from 'react'
import { Modal, NotificationInline, Spacer, View } from 'oio-react'
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { settingsSiteUrl } from 'config/constants/urls'
import DiscountCreate from 'src/components/Settings/DiscountCreate'
import IntegrationStripeListItemRow from 'src/components/Settings/IntegrationStripeListItemRow'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization } from 'src/graphql/hooks'

const SettingsSiteCommerce = () => {
   // TODO: This is a temporary solution to ensure that modals can animate out
   // when the action to close the modal is triggered. A more permanent solution
   // would be to used a state machine that wraps or replaces the Switch below
   // (similar to how TransitionGroup works).
   const [modalIsOpen, setModalIsOpen] = useState(true)
   const history = useHistory()
   const match = useRouteMatch()
   const location = useLocation()

   const { organization } = useOrganization()
   const stripeJustConnected = location.pathname.endsWith('/connect/stripe/success')

   return (
      <View>
         <ProtoReturnBar
            display="block[a-d] none[e-f]"
            returnLinkName="Site Settings"
            returnLinkTo={settingsSiteUrl}
         />
         <View
            display="flex"
            justifyContent="center">
            <View
               maxWidth="100%[a-c] 600px[d-f]"
               padding="40px 20px">
               <View
                  width="100%"
                  display="flex"
                  flexFlow="column[a-c] row[d-f]">
                  <View paddingRight="30px[b-c] 180px[d-f]">
                     <ProtoHeadingBlock
                        title="Commerce & Discounts"
                        description="This platform allows you to easily charge and accept payments for event tickets."
                     />
                  </View>
                  <View flex="0 0 auto" paddingTop="18px">
                     {/*
                     <Button
                        linkTo={`${match.url}/discount-create`}
                        type="submit"
                        name="Create Discount"
                        color="#f7b77c"
                        textColor="#111"
                        textWeight="bold"
                        size="sm"
                        padding="18px"
                     />
                     */}
                  </View>
               </View>
               <Spacer size="3" />
               {stripeJustConnected && (
                  <NotificationInline
                     borderRadius="6px"
                     iconSize="30px"
                     iconSpacing="24px"
                     textSize="1.5"
                     type="success"
                     title="Success!"
                     message="Your Stripe account was connected successfully"
                     paddingHorizontal="24px"
                  />
               )}
               {!organization.commerceEnabled && (
                  <NotificationInline
                     borderRadius="6px"
                     backgroundColor="rgba(247, 183, 124, 0.15)"
                     iconColor="#f7b77c"
                     iconSize="30px"
                     textColor="#333"
                     type="info"
                     title="Please note:"
                     message="You must connect the Stripe payment gateway to accept payments"
                     paddingHorizontal="24px"
                     iconSpacing="24px"
                  />
               )}
               <View
                  width="100%"
                  marginTop="6px"
                  borderRadius="6px"
                  backgroundColor="#fff">
                  <IntegrationStripeListItemRow />
               </View>
               {/*
               <View
                  width="100%"
                  padding="12px 0px">
                  <Spacer size="3" />
                  <Text size="0.9" weight="bold" color="#000" transform="uppercase">
                     Discounts
                  </Text>
               </View>
               <View
                  width="100%"
                  borderRadius="6px"
                  backgroundColor="#fff">
                  <View textAlign="center" padding="30px">
                     <Text size="1.5" color="#888">
                        No discounts have been created yet
                     </Text>
                  </View>
               </View>
               */}
            </View>
         </View>
         <Switch>
            <Route
               path={`${match.url}/discount-create`}
               render={() => (
                  <Modal
                     borderRadius="6px"
                     width="100%[a-b] 330px[c-f]"
                     height="100%[a-b] auto[c-f]"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     open={modalIsOpen}>
                     <DiscountCreate
                        onCloseButtonClick={() => setModalIsOpen(false)}
                     />
                  </Modal>
               )}
            />
         </Switch>
      </View>
   )
}

export default SettingsSiteCommerce
